import React from 'react';
import RelatedGuidesCard from './RelatedGuidesCard';

const Body = ({ resources }) => (
  <div className="px-xl-0 px-3 mb-30">
    <div className="grid__two-items">
      {resources.map((resource) => (
        <RelatedGuidesCard
          key={resource.id}
          title={resource.title}
          content={resource.thumbnailText}
          thumbnail={resource.thumbnail}
          slug={resource.slug}
        />
      ))}
    </div>
  </div>
);

export default Body;
